module.exports = __webpack_public_path__ + "static/media/seguradora_hdi.7cb6c75f.png";